import { render } from "./Announcements.vue?vue&type=template&id=78cb32df&ts=true"
import script from "./Announcements.vue?vue&type=script&lang=ts"
export * from "./Announcements.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__